import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {}

const TripleDot: React.FC<Props> = ({width = 8, height = 3, ...props}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 8 3" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx={1} cy={1.5} r={1} fill="#999998" />
            <circle cx={4} cy={1.5} r={1} fill="#999998" />
            <circle cx={7} cy={1.5} r={1} fill="#999998" />
        </svg>
    );
};

export default TripleDot;
